/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Terms_DescriptionInputs */

const en_meta_terms_description = /** @type {(inputs: Meta_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and conditions for using Lindevo's website and software development services. Governing law: Republic of Latvia.`)
};

const lv_meta_terms_description = /** @type {(inputs: Meta_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo mājaslapas un programmatūras izstrādes pakalpojumu lietošanas noteikumi. Piemērojamie tiesību akti: Latvijas Republikas tiesību akti.`)
};

/**
* | output |
* | --- |
* | "Terms and conditions for using Lindevo's website and software development services. Governing law: Republic of Latvia." |
*
* @param {Meta_Terms_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_terms_description = /** @type {((inputs?: Meta_Terms_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Terms_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_terms_description(inputs)
	return en_meta_terms_description(inputs)
});